module.exports = __webpack_public_path__ + "img/bus_stage.c6c2dd51.svg";